import { NgModule } from '@angular/core';
import { LayoutComponent } from './layout/layout.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'shared/lib/shared.module';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@ngneat/transloco';
import { JOURNAL_TRANSLATION_SCOPE } from 'shared/magic';
import { AttachDirective } from './layout/attach.directive';
import { StoreModule } from '@ngrx/store';
import { layoutFeatureKey, layoutReducer } from '../_reducers/layout.reducer';
import { FooterComponentModule } from './layout/footer/footer.component';

@NgModule({
	declarations: [LayoutComponent, AttachDirective],
	providers: [
		{ provide: TRANSLOCO_SCOPE, useValue: JOURNAL_TRANSLATION_SCOPE, multi: true }
	],
	imports: [
		RouterModule,
		CommonModule,
		TranslocoModule,
		SharedModule,
		FooterComponentModule,
		StoreModule.forFeature(layoutFeatureKey, layoutReducer)
	],
	exports: [LayoutComponent, AttachDirective]
})
export class LayoutModule { }
